import { useMutation, useQuery } from '@apollo/client';
import { Avatar, Box, Button, FormControl, FormLabel, Grid, GridItem, Input, Text, useToast } from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { UPDATE_PROFILE_DATA_MUTATION } from '../../../Components/Graphql/Mutations';
import { GET_USER_DATA } from '../../../Components/Graphql/Queries';

const textStyles = {
  marginTop: '23px',
  fontSize: 'sm',
  marginBottom: '3px'
}

const inputStyles = {
  padding: '8px 15px',
  bgColor: '#F3F3F3',
  height: '46px',
  border: 'none',
  borderRadius: '5px',
  w: '100%',
  color: 'black',
  fontSize: '14px',
}

const AdminProfile = () => {
  const toast = useToast();
  const [updateProfileDataMutation, updateProfileData] = useMutation(UPDATE_PROFILE_DATA_MUTATION);
  const { loading, error, data, refetch } = useQuery(GET_USER_DATA);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [profileUrl, setProfileUrl] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(false);

  const token = sessionStorage.getItem('token');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "firstName") {
      setFirstName(value);
    }
    else if (name == "lastName") {
      setLastName(value);
    }
  };

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedProfile(file);
      console.log("profile pic:", file);
    }

  };

  useEffect(() => {

    console.log("error in update profile mutation:", updateProfileData.error)
    console.log("loading update profile mutation:", updateProfileData.loading)
    console.log("data update profile mutation:", updateProfileData.data)

    if (updateProfileData.data != undefined) {
      if (updateProfileData?.data?.updateProfileData?.success) {
        toast({
          title: 'Succeed',
          description: 'Profile Updated Successfully',
          status: 'success',
          duration: 4000,
          isClosable: true
        });
      }
      else {
        toast({
          title: 'error',
          description: updateProfileData?.data?.updateProfileData?.message,
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      }

    }
    if (updateProfileData.error != undefined) {
      toast({
        title: 'error',
        description: updateProfileData.error.message,
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    }
  }, [updateProfileData.data, updateProfileData.loading, updateProfileData.error])
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const UpdateProfileDataInput = {
        firstName: firstName,
        lastName: lastName,
        profileImage: profileUrl
      };
      console.log('name:', UpdateProfileDataInput);

      await updateProfileDataMutation({ variables: UpdateProfileDataInput });
      await refetch();
    } catch (error) {
      console.log("Error from update profile mutation: ", error);
    }

  };

  useEffect(() => {

    console.log("error:", error)
    console.log("loading:", loading)
    console.log("data:", data)

    if (data != undefined) {
      console.log("data of user: ", data);
      setFirstName(data.getUserData.firstName);
      setLastName(data.getUserData.lastName);
      setEmail(data.getUserData.email);
      setPhoneNo(data.getUserData.phoneNumber);
      setProfileUrl(data.getUserData.profileImage);

      console.log("firstName", firstName);
    }
    if (error != undefined) {
      toast({
        title: 'error',
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    }
  }, [data, loading, error]);

  const handleFileUpload = async () => {
    try {
      setLoadingProfile(true);
      const formData = new FormData();
      formData.append("files", selectedProfile);

      const response = await axios.post('https://asset-tokenization-liart.vercel.app/s3/upload', formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      console.log('File upload response:', response.data);
      setProfileUrl(response.data[0]);
      setLoadingProfile(false);
      toast({
        title: 'Succeed',
        description: 'Photo Uploaded Successfully',
        status: 'success',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    } catch (error) {
      console.error('Error uploading file:', error);
      setLoadingProfile(false);
      toast({
        title: 'error',
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: "bottom-left"
      });
    }
  };

  return (
    <Box w='100%'>
      <Text fontSize='20px' color='#333' marginLeft='30px' marginBottom='10px'>
        Profile
      </Text>
      <Box color='#315B84' background='#FFFFFF' padding='20px 25px 15px 25px' w='100%' borderRadius='15px'>
        <Grid templateColumns={{ base: 'repeat(1,1fr)', lg: 'repeat(12, 1fr)' }} gap={5}>
          <GridItem colSpan={{ base: "12", lg: "5" }} mx="auto">
            <form onSubmit={handleSubmit}>
              <FormControl isRequired>
                <FormLabel {...textStyles} mt='0px'>
                  First Name:
                </FormLabel>
                <Input
                  placeholder='Enter your First Name'
                  type="text"
                  name="firstName"
                  value={firstName}
                  onChange={handleInputChange}
                  {...inputStyles}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel {...textStyles}>
                  Last Name:
                </FormLabel>
                <Input
                  placeholder='Enter your Last Name'
                  type="text"
                  name="lastName"
                  value={lastName}
                  onChange={handleInputChange}
                  {...inputStyles}
                />
              </FormControl>
              <Text {...textStyles}>
                Email Address:
              </Text>
              <Input
                placeholder='Enter your Email Address'
                value={email}
                isReadOnly
                {...inputStyles}
              />
              <Text {...textStyles}>
                Phone Number:
              </Text>
              <Input
                placeholder='Enter you Phone Number'
                value={phoneNo}
                isReadOnly
                {...inputStyles}
              />
              <Text {...textStyles}>
                Broker Dealer ID:
              </Text>
              <Input isReadOnly {...inputStyles} />
              <Button
                type="submit"
                marginTop='20px'
                w='100%'
                fontWeight='300'
                backgroundColor='#0d6efd'
                color='white'
                isLoading={updateProfileData?.loading}
                _hover={{
                  backgroundColor: '#0a58ca'
                }}
              >
                Save Changes
              </Button>
            </form>
          </GridItem>
          <GridItem colSpan={1} />
          <GridItem colSpan={{ base: "12", lg: "5" }}>
            <Box display='flex' alignItems='center' marginTop='20px' flexDirection='column'>
              <Avatar
                name={firstName}
                src='https://bit.ly/broken-link'
                height='120px'
                width='120px'
                marginBottom='30px'
              />
              <Box mt='10px' border='1px #eee solid' padding='10px 12px 0px' w='100%'>
                <Input background='#F3F3F3' type='file' padding='8px 15px' height='52px' onChange={handleProfileChange} />
                <Button
                  marginY='20px'
                  w='100%'
                  fontWeight='300'
                  backgroundColor='#0d6efd'
                  color='white'
                  _hover={{
                    backgroundColor: '#0a58ca'
                  }}
                  height='31px'
                  borderRadius='5px'
                  onClick={handleFileUpload}
                  isLoading={loadingProfile}
                >
                  Upload
                </Button>
              </Box>
              <Text textAlign='center' marginTop='5px' fontSize='14px'>
                Max size for file 20Mb. Use square photo for best results
              </Text>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </Box>
  )
}

export default AdminProfile